import { createSlice, PayloadAction } from '@reduxjs/toolkit'
// constants
import { Forms } from 'constants/forms'
import { Reducers } from 'store/types'

interface AccumulatedFormDataPayload {
  type: string;
  data?: Record<string, any>;
}

interface AccumulatedFormState {
  [key: string]: Record<string, any>;
}

const initialState: AccumulatedFormState = {
  [Forms.ACCUMULATED_CREATE_ACCOUNT]: {}
}

export const accumulatedFormSlice = createSlice({
  name: Reducers.ACCUMULATED_FORMS,
  initialState,
  reducers: {
    setAccumulatedFormData: (state, action: PayloadAction<AccumulatedFormDataPayload>) => {
      const { type, data } = action.payload
      state[type] = {
        ...state[type],
        ...data
      }
    },
    resetAccumulatedFormData: (state, action: PayloadAction<{ type: string }>) => {
      const { type } = action.payload
      state[type] = {}
    }
  }
})

export const { setAccumulatedFormData, resetAccumulatedFormData } = accumulatedFormSlice.actions
